<template>
  <div v-loading="$wait.waiting(_uid)" class="card">
    <div class="card-content">
      <div class="row">
        <div class="col-xs-12">
          <div class="text-right wrapper-button control-button-wrapper pt-xxs">
            <acl :permissions="['companies_destroy']">
              <button
                class="btn btn-danger btn-wd submit-button"
                @click="handleDeleteCompany"
              >
                Delete
              </button>
            </acl>

            <button
              class="btn btn-cancel btn-primary btn-wd"
              @click="goBackToProfile"
            >
              Cancel
            </button>

            <acl :permissions="['companies_update']">
              <button
                class="btn btn-info btn-fill btn-wd submit-button"
                @click.prevent="handleUpdateCompanyProfile"
              >
                Update
              </button>
            </acl>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <fg-input v-model="model.name" type="text" label="Company name" />
        </div>
      </div>

      <acl :roles="['Admin', 'Customer Support']">
        <div class="row my-10">
          <div class="col-xs-12">
            <b> Tier </b>
            <div class="clearfix mb-xxxs" />
            <el-select
              v-model="model.tier.id"
              class="select-default"
              placeholder="Select Tier"
            >
              <el-option
                v-for="tier in tiers"
                :key="tier.id"
                class="select-default"
                :label="tier.name"
                :value="tier.id"
              />
            </el-select>
          </div>
        </div>
      </acl>

      <acl :roles="['Admin', 'Customer Support']">
        <div class="row mt-xs">
          <div
            class="form-group col-xs-12"
            :class="{ 'has-error': inputError }"
          >
            <fg-input
              v-model="model.salesForce"
              type="url"
              label="Salesforce account"
              placeholder="https://example.com"
              class="mb-xxxs"
            />
            <small v-if="inputError" class="control-label">{{
              inputError
            }}</small>
          </div>
        </div>
      </acl>

      <acl :roles="['Admin', 'Customer Support']">
        <hr />

        <div class="row mb-s pb-s">
          <div class="card-header pt-xxxs">
            <h4 class="title mt-xxxs">Operational Information</h4>
          </div>

          <acl :permissions="['companies_rpes']">
            <div class="col-md-6 col-xs-12">
              <div class="form-group text-left">
                <label for="notification" class="mr-xs">
                  Registry, Purpose, Equipment
                </label>

                <ul class="list-unstyled mt-s">
                  <li v-for="rpe in myRpes" :key="rpe.id">
                    <div
                      class="wrapper-switch"
                      @click="setOperationalList('rpes', rpe.id)"
                    >
                      <p-switch
                        v-model="rpe.status"
                        type="primary"
                        name="notification"
                        class="mr-xxs"
                      />
                      {{ rpe.name }}
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </acl>

          <acl :permissions="['companies_roles']">
            <div class="col-md-6 col-xs-12">
              <div class="form-group text-left">
                <label for="notification" class="mr-xs"> Roles </label>

                <ul class="list-unstyled mt-s">
                  <li v-for="role in myRoles" :key="role.id">
                    <div
                      class="wrapper-switch"
                      @click="setOperationalList('roles', role.id)"
                    >
                      <p-switch
                        v-model="role.status"
                        type="primary"
                        name="notification"
                        class="mr-xxs"
                      />
                      {{ role.name }}
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </acl>
        </div>
      </acl>

      <div class="clearfix mb-s" />
    </div>
  </div>
</template>
<script>
import PSwitch from "@components/UIComponents/Switch.vue";
import _get from "lodash.get";
import _xorWith from "lodash.xorwith";
import _cloneDeep from "lodash.clonedeep";
import { mapGetters, mapState, mapActions, mapMutations } from "vuex";

export default {
  components: {
    PSwitch,
  },
  data() {
    return {
      inputError: false,
      model: {
        tier: {},
      },
    };
  },
  computed: {
    ...mapState("companyStore", {
      company: "company",
    }),
    ...mapGetters("companyStore", ["isLoading", "roles", "rpes", "tiers"]),
    myRoles() {
      return this.getOperationalList("roles");
    },
    myRpes() {
      return this.getOperationalList("rpes");
    },
  },
  async mounted() {
    await this.getCompanyById(this.company.id);

    this.model = _cloneDeep(this.company);

    this.getRoles();
    this.getRpes();
    this.getTiers();
  },
  methods: {
    ...mapActions("companyStore", [
      "getCompanyById",
      "getRoles",
      "getRpes",
      "getTiers",
      "deleteCurrentCompany",
      "updateCompany",
    ]),
    ...mapActions("errorStore", ["addNewError"]),
    ...mapMutations("companyStore", ["setLoading"]),
    ...mapMutations("errorStore", ["clearErrors"]),
    clearInputError() {
      this.inputError = false;
    },
    async handleDeleteCompany() {
      await this.deleteCurrentCompany({
        onSuccess: () => this.$router.push({ name: "home" }),
      });
    },
    getOperationalList(list) {
      const allOperationals = this[list];

      if (!allOperationals) {
        return [];
      }

      const currentOperationals = _get(this, `model.${list}`, []);

      return allOperationals.map(({ name, id }) => {
        const status = currentOperationals.some(
          ({ id: currentId }) => id === currentId
        );

        return { name, id, status };
      });
    },
    setOperationalList(list, id) {
      this.model[list] = _xorWith(
        this.model[list],
        [{ id }],
        (a, b) => a.id === b.id
      );
    },
    async handleUpdateCompanyProfile() {
      this.$wait.start(this._uid);

      try {
        await this.updateCompany(this.model);

        this.$notify({
          message: "Data updated successfully!",
          horizontalAlign: "center",
          verticalAlign: "top",
          type: "success",
        });

        setTimeout(this.goBackToProfile, 400);
      } catch (error) {
        this.addNewError(error);
      } finally {
        this.$wait.end(this._uid);
      }
    },
    goBackToProfile() {
      return this.$router.push({ name: "companies@show" });
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-cancel {
  margin: 0 12px;
}
@media (max-width: 1024px) {
  .wrapper-button .btn {
    width: 100%;
  }
  .btn-cancel {
    margin: 12px 0;
  }
}
</style>
